import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Swal from "sweetalert2";
import { apiRequest } from '../ApiService/Allapi';

function Blog() {
  const [blogs, setBlogs] = useState([]);

  const [selectedBlog, setSelectedBlog] = useState(() => {
    const saved = localStorage.getItem("selectedBlog");
    return saved ? JSON.parse(saved) : null;
  });

  // Remove HTML tags
  const stripHtml = (html) => html?.replace(/<[^>]*>?/gm, '') || '';

  const fetchBlogs = async () => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest('get-blogs', "GET", null, headers);
      if (res.status === true) {
        setBlogs(res.data);
      } else {
        Swal.fire("Error", res.message || "Failed to fetch blogs", "error");
      }
    } catch (error) {
      Swal.fire("Error", "Something went wrong while fetching data!", "error");
    }
  };

  const handleBlogClick = (blog) => {
    setSelectedBlog(blog);
    localStorage.setItem("selectedBlog", JSON.stringify(blog));
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleBack = () => {
    setSelectedBlog(null);
    localStorage.removeItem("selectedBlog");
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  if (selectedBlog) {

    return (
      <div className="container my-5">
        <Button variant="secondary" onClick={handleBack} className="mb-4">
          &larr; Back to Blogs
        </Button>

        <div className="single-blog-detail">
          <h1>{selectedBlog.title}</h1>
          <div className="blog-meta mb-3">
            <span className="category">
              <i className="fas fa-tag"></i> {selectedBlog.category || "Uncategorized"}
            </span>
            <span className="date ms-3">
              <i className="far fa-calendar"></i> {new Date(selectedBlog.created_at).toLocaleDateString()}
            </span>
          </div>

          <img
            src={selectedBlog.image}
            alt={selectedBlog.title}
            className="img-fluid mb-4"
            style={{ maxHeight: "500px", width: "100%", objectFit: "cover" }}
          />

          <div className="blog-content" dangerouslySetInnerHTML={{ __html: selectedBlog.content }} />
        </div>
      </div>
    );
  }

  return (
    <>
      {/* Banner */}
      <div className='blog_main' style={{
        backgroundImage: `url("https://shivshankartirthyatra.com/blog/wp-content/uploads/2025/02/banner.png")`,
        backgroundSize: "cover",
        backgroundPosition: "right bottom",
        backgroundRepeat: "no-repeat",
        display: "flex",
        alignItems: "center",
        padding: "130px 0",
        justifyContent: "center",
        color: "white"
      }}>
        <div className='blog_main_content text-center'>
          <h1>Om Shiv Shankar Tirth Yatra Blogs</h1>
        </div>
      </div>

      {/* Blog Grid */}
      <div className='container my-5'>
        <div className='row'>
          {blogs.map((blog) => (
            <div className='col-lg-4 mb-4' key={blog.id}>
              <div
                className='tour-blog shdo'
                onClick={() => handleBlogClick(blog)}
                style={{ cursor: 'pointer' }}
              >
                <div className="single-blog-img-">
                  <img
                    src={blog.image}
                    alt={blog.title}
                    className="img-fluid"
                    style={{ height: "200px", width: "100%", objectFit: "cover" }}
                  />
                </div>

                <div className="entry-blog-post dg-bg2 px-2 pt-2">
                  <span className="bypost-" style={{ fontSize: "12px" }}>
                    <i className="fas fa-tag"></i> {blog.category || "Uncategorized"}
                  </span>
                </div>

                <div className="blog-content-tt px-3 pb-3">
                  <h4>{blog.title}</h4>
                  {stripHtml(blog.content).substring(0, 100)}
                  <div className="post-social mt-2">
                    <button className="btn btn-dark rounded-0 px-4 py-2">
                      Continue Reading <i className="fas fa-arrow-right ms-2"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default Blog;
